import React from 'react';

import { useLocation } from 'react-router-dom';

import { useUIContext } from 'state/ui';
import { isExternalLink } from 'utils/is-external-link';
import { optionToUrl } from 'utils/menu';
import { useIsBrowseMenu } from 'utils/menu/hooks/use-is-browse-menu';

import { Tile, TileExternal, TileImageWrapper, TileLabel } from './styles';
import { IMenuOptionScrollerTable } from './types';

export const CAROUSEL_HEIGHT = 0;

const MenuOptionScrollerTile: React.FC<IMenuOptionScrollerTable> = ({ section }) => {
  const { buildImageUrl } = useUIContext();
  const { pathname } = useLocation();

  const { isBrowseMenu } = useIsBrowseMenu(pathname);

  const redirectUrl = section.redirectLink?.locale;
  const image = section.carouselImage;
  const name = section.name?.locale;

  const tileContent = (
    <>
      <TileImageWrapper data-testid="menu-option-scroller-tile-image">
        {image && image.asset && <img src={buildImageUrl(image, { height: 70 })} alt="" />}
      </TileImageWrapper>
      <TileLabel as="span" id={section._id}>
        {name}
      </TileLabel>
    </>
  );

  if (redirectUrl && isExternalLink(redirectUrl)) {
    return (
      <TileExternal href={redirectUrl} data-testid={`menu-option-scroller-tile-${name}`}>
        {tileContent}
      </TileExternal>
    );
  }

  return (
    <Tile
      to={redirectUrl || optionToUrl(section, isBrowseMenu)}
      noBorder
      data-testid={`menu-option-scroller-tile-${name}`}
    >
      {tileContent}
    </Tile>
  );
};

export default MenuOptionScrollerTile;
